// extracted by mini-css-extract-plugin
export default {"last-order":"OrderTrackerList_last-order__m6x+5","track-order-more-text":"OrderTrackerList_track-order-more-text__+IcwM","track-title":"OrderTrackerList_track-title__2dC-k"};